import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=d066b63a&scoped=true&"
import script from "./SimpleList.vue?vue&type=script&lang=ts&"
export * from "./SimpleList.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleList.vue?vue&type=style&index=0&id=d066b63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d066b63a",
  null
  
)

export default component.exports